import React from 'react';
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Typography,
    useTheme,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLogoutModal } from 'store/LogoutModalProvider';

interface SideBarProps {
    open: boolean;
    onClose: () => void;
}

const SideBar = ({ open, onClose }: SideBarProps) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const { openLogoutModal } = useLogoutModal();

    const menuItems = [
        {
            text: '儀表盤',
            path: '/',
        },
        {
            text: '旗袋數據',
            path: '/bag-list',
        },
        {
            text: '設定',
            path: '/setting',
        },
    ];

    const handleNavigation = (path: string) => {
        navigate(path);
        onClose();
    };

    const handleLogout = () => {
        openLogoutModal();
        onClose();
    };

    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={onClose}
            sx={{
                '& .MuiDrawer-paper': {
                    width: 220,
                    boxSizing: 'border-box',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 2,
                        pt: 3,
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 700,
                            color: "#269FFF",
                            letterSpacing: '-0.5px',
                        }}
                    >
                        <img 
                            src='/images/Frame 583.svg' 
                            alt="Lumio" 
                            style={{ width: '120px', height: 'auto', maxWidth: '100%' }} // 調整大小
                        />
                    </Typography>
                </Box>

                <Box sx={{ flex: 1, px: 2, pt: 1 }}>
                    <List sx={{ p: 0 }}>
                        {menuItems.map((item) => {
                            const isActive = location.pathname === item.path;
                            return (
                                <ListItem key={item.text} disablePadding sx={{ mb: "12px" }}>
                                    <ListItemButton
                                        onClick={() => handleNavigation(item.path)}
                                        sx={{
                                            borderRadius: "69px",
                                            py: 1.5,
                                            px: 2,
                                            backgroundColor: isActive ? "#269FFF" : "#fff",
                                            color: isActive ? "#fff" : "#000",
                                            '&:hover': {
                                                backgroundColor: "#1565c0",
                                                color: "#fff",
                                            },
                                        }}
                                    >
                                        <ListItemText
                                            primary={item.text}
                                            primaryTypographyProps={{
                                                fontSize: 15,
                                                fontWeight: isActive ? 500 : 400,
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
                    </List>
                </Box>

                <Box sx={{ p: 2 }}>
                    <ListItemButton
                        onClick={handleLogout}
                        sx={{
                            borderRadius: 2,
                            py: 1.5,
                            px: 2,
                            '&:hover': {
                                backgroundColor: theme.palette.error.light + '20',
                            },
                        }}
                    >
                        <ListItemText
                            primary="登出"
                            primaryTypographyProps={{
                                fontSize: 15,
                                fontWeight: 500,
                                textAlign: 'center',
                                color: theme.palette.error.main,
                            }}
                        />
                    </ListItemButton>
                </Box>
            </Box>
        </Drawer>
    );
};

export default SideBar;
